import ReactDOM from "react-dom/client"

import { Provider } from "react-redux"
import store from "../src/store"

import "./index.css"
import App from "./App"

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
)
root.render(
    <Provider store={store}>   
        <App />
    </Provider>
)

serviceWorkerRegistration.register();